import {REGISTER_USER, LOGIN, LOGOUT} from '../actions/types';

const initialState = {
  user: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER:
      return {
        ...state,
        user: action.payload,
      };
  
    case LOGIN:
      return {
        ...state,
        user: action.payload,
      };
    case LOGOUT:

      return {
        ...state,
        user: null,
      };

    
    default:
      return state;
  }
};

export default authReducer;
